// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s0vHkywpGYBQRx7AjQN3{padding:0 24px 16px}.jjVkHUfPamoVGn_oSOH5{padding:0 24px 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `s0vHkywpGYBQRx7AjQN3`,
	"wrapOptions": `jjVkHUfPamoVGn_oSOH5`
};
export default ___CSS_LOADER_EXPORT___;
